/* eslint-disable react/prop-types */
/*  eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import {
  SelectDropdown,
  Button,
  RequiredFieldIndicator,
  StatusBadge,
} from '@gsa/afp-component-library';
import MakeModelTypeAheadGroup from '../../../../components/make-model/make-model-typeahead-group';
import '../../../fvs/requirements/components/make-model/make-model-table.scss';
import { useBidMakeAndModelContext } from './make-and-model-provider';
import { getMakeModelStatusBadge } from '../../helpers';
import { emDashUnicode } from '../../../../utilities/constants';
import CanIChangeBidData from '../../../bids/components/protect-bid-data-crud';

const MakeAndModelHeader = ({ title, required }) => {
  return (
    <div className="titleHeader" aria-label={title} tabIndex="0">
      {title}
      {required && (
        <span className="margin-left-05">
          <RequiredFieldIndicator />
        </span>
      )}
    </div>
  );
};

const HEADER_TITLES = {
  bodyMake: 'Body Make',
  bodyModel: 'Body Model',
  chassisMake: 'Chassis Make',
  chassisModel: 'Chassis Model',
};

const MakeAndModelSearchPanel = ({
  hasChassis,
  onAddMakeModel,
  action,
  disabled = false,
}) => {
  const state = useBidMakeAndModelContext();
  const { status, modelYear, setModelYear } = state;

  const handleModelYearChanged = (val) => {
    setModelYear(val);
  };

  const getModelYearRange = (previousYears, nextYears) => {
    const currentYear = new Date().getFullYear();
    const years = [{ value: '', label: '-Select-' }];
    for (
      let i = currentYear - previousYears;
      i <= currentYear + nextYears;
      i += 1
    ) {
      years.push({ value: i, label: i.toString() });
    }
    return years;
  };

  const badge = getMakeModelStatusBadge(status);

  return (
    <>
      <div className="grid-row grid-gap bg-primary-lighter padding-top-2">
        <MakeModelTypeAheadGroup
          state={state}
          showChassis={hasChassis}
          requiresChassis
          disablePaste
          fieldWrapperClassName="grid-col flex-1"
          renderFieldHeader={(field) => (
            <MakeAndModelHeader title={HEADER_TITLES[field]} required />
          )}
        />
        <div className="grid-col flex-1">
          <MakeAndModelHeader title="Model year" required />
          <SelectDropdown
            name="model_year"
            onChange={({ target: { value } }) => handleModelYearChanged(value)}
            value={modelYear}
            options={getModelYearRange(1, 3)}
            className="margin-top-4"
          />
        </div>
        {action === 'add' && (
          <div className="grid-col flex-1">
            <CanIChangeBidData>
              <Button
                leftIcon={{
                  name: 'add',
                }}
                type="button"
                variant="outline"
                onClick={onAddMakeModel}
                label="Add"
                aria-label="Add"
                className="margin-top-7"
                disabled={disabled}
              />
            </CanIChangeBidData>
          </div>
        )}
        {action === 'update' && (
          <div className="grid-col flex-1">
            <MakeAndModelHeader title="Status" />
            <div className="margin-top-4">
              {badge ? (
                <StatusBadge variant={badge.variant}>{badge.label}</StatusBadge>
              ) : (
                emDashUnicode
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MakeAndModelSearchPanel;
